// src/App.jsx
import { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import "./App.css";

// Páginas públicas
import Home from "./pages/home/home";
import Nosotros from "./pages/nosotros/nosotros";
import Asesoria from "./pages/asesoria/asesoria";
import Emprendimiento from "./pages/emprendimiento/emprendimiento";
import Educate from "./pages/educate/educate";
import Empleos from "./pages/empleos/empleos";
import Migration from "./pages/migration/migration";
import PequenosNegocios from "./pages/pequenosnegocios/pequenosnegocios";
import Planes from "./pages/planes/planes";
import Error404 from "./pages/error404/error404";
import Contacto from "./pages/contacto/contacto";
import Employmentsection from "./pages/empleos/employmentsection";
import Posts from "./components/posts";

// Autenticación
import Choice from "./pages/auth/choice";
import Login from "./pages/auth/login";
import Register from "./pages/auth/register";
import EmailConfirmation from "./pages/auth/emailconfirmation";
import ForgotPassword from "./pages/auth/forgotpassword.jsx";
import ResetPassword from "./pages/auth/resetpassword.jsx";

// Confirmación y callbacks
import CorreoConfirmado from "./pages/auth/correoconfirmado";
import Confirm from "./pages/auth/confirm";
import GoogleCallback from "./pages/auth/GoogleCallback";
import FacebookCallback from "./pages/auth/FacebookCallback";
import MicrosoftCallback from "./pages/auth/MicrosoftCallback";

// Dashboard y "Mi Cuenta"
import MiCuenta from "./pages/micuenta/MiCuenta";
import PaymentMethods from "./pages/micuenta/MetodosDePago";
import Facturacion from "./pages/micuenta/Facturacion";
import Curriculum from "./pages/micuenta/Curriculum";
import Suscripciones from "./pages/micuenta/Suscripciones";
import ConfiguracionSeguridad from "./pages/micuenta/ConfiguracionSeguridad"; // NUEVO

// Rutas específicas para USUARIO
import EmpleosAplicados from "./pages/micuenta/EmpleosAplicados";
import Favoritos from "./pages/micuenta/Favoritos";
import DatosPersonales from "./pages/micuenta/DatosPersonales.jsx";

// Rutas específicas para EMPLEADOR
import PublicarEmpleo from "./pages/micuenta/PublicarEmpleo";
import EmpleosPublicados from "./pages/micuenta/EmpleosPublicados";
import Candidatos from "./pages/micuenta/Candidatos";
import EditarEmpleo from "./pages/micuenta/EditarEmpleo";
import DetallesEmpleo from "./pages/micuenta/DetallesEmpleo";
import DetallePublicoEmpleo from "./pages/empleos/DetallePublicoEmpleo";

// Empleo y carrito
import AplicarParaEmpleo from "./pages/empleos/AplicarParaEmpleo";
import Cart from "./pages/cart/cart.jsx";

// Legales
import TerminosYCondiciones from "./components/TerminosYCondiciones";
import PoliticasDePrivacidad from "./components/PoliticasDePrivacidad";

// Componentes globales
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import MobileMenu from "./components/mobilemenu.jsx";
import SocialFloatingMenu from "./components/SocialFloatingMenu.jsx";

// Rutas protegidas y contextos
import { AuthProvider } from "./context/AuthContext.jsx";
import PrivateRoute from "./components/PrivateRoute.jsx";

// Overlays de carga
import LoadingOverlay from "./components/LoadingOverlay";
import EntranceLoadingOverlay from "./components/EntranceLoadingOverlay";

const AppContent = () => {
  const location = useLocation();
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  return (
    <>
      <ScrollToTop />
      <div className="page-container">
        <Header />
        <div className="content-wrap">
          <Routes>
            {/* Páginas públicas */}
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/asesoria" element={<Asesoria />} />
            <Route path="/emprendimiento" element={<Emprendimiento />} />
            <Route path="/educate" element={<Educate />} />
            <Route path="/empleos" element={<Empleos />} />
            <Route path="/migration" element={<Migration />} />
            <Route path="/pequenosnegocios" element={<PequenosNegocios />} />
            <Route path="/employmentsection" element={<Employmentsection />} />
            <Route path="/planes" element={<Planes />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/posts" element={<Posts />} />

            {/* Autenticación */}
            <Route path="/choice" element={<Choice />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/email-confirmation" element={<EmailConfirmation />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/confirm" element={<Confirm />} />

            {/* Callbacks de autenticación social */}
            <Route path="/auth/google/callback" element={<GoogleCallback />} />
            <Route path="/auth/facebook/callback" element={<FacebookCallback />} />
            <Route path="/auth/microsoft/callback" element={<MicrosoftCallback />} />

            {/* Legales */}
            <Route path="/terminos" element={<TerminosYCondiciones />} />
            <Route path="/politicas-de-privacidad" element={<PoliticasDePrivacidad />} />

            {/* Rutas protegidas ("Mi Cuenta") */}
            <Route
              path="/mi-cuenta"
              element={
                <PrivateRoute>
                  <MiCuenta user={user} />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/configuracion-seguridad"
              element={
                <PrivateRoute>
                  <ConfiguracionSeguridad />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/metodos-pago"
              element={
                <PrivateRoute>
                  <PaymentMethods />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/facturacion"
              element={
                <PrivateRoute>
                  <Facturacion />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/curriculum"
              element={
                <PrivateRoute>
                  <Curriculum />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/suscripciones"
              element={
                <PrivateRoute>
                  <Suscripciones />
                </PrivateRoute>
              }
            />

            {/* Rutas específicas para USUARIO */}
            <Route
              path="/mi-cuenta/empleos-aplicados"
              element={
                <PrivateRoute requiredUserType="user">
                  <EmpleosAplicados />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/favoritos"
              element={
                <PrivateRoute requiredUserType="user">
                  <Favoritos />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/datos-personales"
              element={
                <PrivateRoute>
                  <DatosPersonales />
                </PrivateRoute>
              }
            />

            {/* Rutas específicas para EMPLEADOR */}
            <Route
              path="/mi-cuenta/publicar-empleo"
              element={
                <PrivateRoute requiredUserType="employer">
                  <PublicarEmpleo />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/empleos-publicados"
              element={
                <PrivateRoute requiredUserType="employer">
                  <EmpleosPublicados />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/empleos-publicados/editar/:jobId"
              element={
                <PrivateRoute requiredUserType="employer">
                  <EditarEmpleo />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/empleos-publicados/detalles-empleo/:jobId"
              element={
                <PrivateRoute requiredUserType="employer">
                  <DetallesEmpleo />
                </PrivateRoute>
              }
            />
            <Route
              path="/mi-cuenta/candidatos"
              element={
                <PrivateRoute requiredUserType="employer">
                  <Candidatos />
                </PrivateRoute>
              }
            />

            {/* Otras rutas públicas */}
            <Route path="/detalle-empleo/:jobId" element={<DetallePublicoEmpleo />} />
            <Route path="/aplicar" element={<AplicarParaEmpleo />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/correo-confirmado" element={<CorreoConfirmado />} />

            {/* Ruta 404 */}
            <Route path="*" element={<Error404 />} />
          </Routes>
        </div>
        <Footer />
        <MobileMenu />
        {location.pathname === "/" && <SocialFloatingMenu />}
      </div>
    </>
  );
};

function App() {
  const [loading, setLoading] = useState(false);

  return (
    <AuthProvider>
      <Router>
        <EntranceLoadingOverlay />
        {loading && <LoadingOverlay />}
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;